<template>
    <div class="modal fade" id="participationRequestModal" role="dialog" aria-labelledby="participationRequestModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header mt-3 mb-0">
                    <h5 class="modal-title" id="participationRequestModalLabel">{{$t('participationConfirmation.modalTitle')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <ConfirmationEditCard v-model="model"
                                          v-if="showEditor"
                                          @save="onSave"
                                          @cancel="onCancel">
                    </ConfirmationEditCard>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { TempRankingToPersonModel } from '@/models/models';
    import ConfirmationEditCard from '@/components/dynamic/events/accommodationRequest/ConfirmationEditCard';

    export default {
        components: {
            ConfirmationEditCard
        },
        props: {
            value: {
                type: Object,
                required: false
            },
            show: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                showEditor: false,
                model: new TempRankingToPersonModel(),
            };
        },
        methods: {
            onClose() {
                this.$emit('onClose', { ...this.model });
                this.model = new TempRankingToPersonModel();
                this.$validator.reset();
            },
            hide() {
                $(this.$el).modal('hide');
            },
            onSave(model) {
                this.$emit('onCreate', model);
                this.onClose();
            },
            onCancel() {
                this.onClose();
            }
        },
        mounted() {
            // add modal close listener
            $(this.$el).on('hidden.bs.modal', this.onClose);
        },
        beforeDestroy() {
            // remove listener
            $(this.$el).off('hidden.bs.modal');
        },
        watch: {
            show: function (val) {
                if (val) {
                    this.model = new TempRankingToPersonModel(this.value);
                    this.showEditor = true;
                    $(this.$el).modal('show');
                } else {
                    $(this.$el).modal('hide');
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .bmd-form-group {
        padding-top: 0px !important;
    }
</style>
